module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"undp-iceland","accessToken":"MC5aLUU2WWhNQUFDMEFxU0w1.PhEC77-9Gu-_ve-_vQRg77-9c--_vQFW77-977-977-977-9ce-_ve-_vWHvv73vv73vv71e77-9Gz5AYjU","promptForAccessToken":true,"apiEndpoint":"https://undp-iceland.cdn.prismic.io/api/v2","lang":"*","imageImgixParams":{"auto":"compress,format","fit":"max","q":50},"imagePlaceholderImgixParams":{"w":100,"blur":15},"toolbar":"new"},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"undp-blir-varlden-battre","short_name":"undp","start_url":"/","background_color":"#000000","display":"minimal-ui","icon":"src/assets/favicon/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"f6f794807a72a9921abf9bc473719715"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
